/** @jsx jsx */
import { jsx, Grid, Box, Flex, Image } from 'theme-ui'
import BTPGraphic from '../images/BTP-graphic2-400.png'
import BTPGraphic2 from '../images/BTP-graphic1-400.png'
import MicGraphic from '../images/mic.svg'
import Code from '../images/code.svg'
import Layout from '../components/layout'
import SEO from '../components/seo'
import Sparkles from '../components/sparkles'
import FeaturedIn from '../components/featured-in'
import { FaRegEdit, FaSuitcase, FaRegBell, FaRegEnvelope } from 'react-icons/fa'
import Stopwatch from '../images/new-homepage/BTP_stopwatch.png'
import Profile from '../images/new-homepage/BTP_profile.png'
import NinetyDays from '../images/new-homepage/BTP_90days.png'
import NoSpam from '../images/new-homepage/BTP_nospam.png'
import Testimonials from '../images/new-homepage/BTP_testimonials.png'
import Review from '../images/new-homepage/BTP_review.png'

const IndexPage = () => (
  <Layout activeMenu="index">
    <SEO title="Home" />
    <Flex
      className="bg-li"
      sx={{
        flexDirection: ['column', 'column', 'row'],
        justifyContent: 'space-around',
        alignItems: 'center',
        paddingTop: '32px',
        paddingBottom: '32px',
        paddingLeft: 4,
      }}
    >
      <Box
        sx={{
          width: ['100%', '100%', '50%'],
          p: [20, 0],
          marginBottom: '20px',
        }}
      >
        <h2
          sx={{ fontSize: '1.5em', fontWeight: 400 }}
          className="w3ls_pvt-title"
        >
          INTRODUCING BTP TALENTMATCH
          <br />
        </h2>
        <h1 sx={{ fontSize: '2.5em' }} className="w3ls_pvt-title">
          Sign up and get matched with vetted companies that value Black tech
          talent.
          <br />
        </h1>
        <Box sx={{ fontSize: 2 }} as="p">
          No toxic workplaces and no spammy recruiter emails allowed. BTP
          TalentMatch puts you in control of the recruitment process by vetting
          prospective companies, anonymizing your information, and only making
          the connections that interest you.
        </Box>
        <Box sx={{ fontSize: 2 }} as="p">
          Click below to create your TalentMatch profile and get connected to
          companies committed to supporting you beyond the onboarding process.
        </Box>

        <Sparkles>
          <a
            href="https://app.blacktechpipeline.com/signup"
            target="_blank"
            rel="noopener noreferrer"
            className="btn button-style mt-md-5 mt-4 read-more"
            sx={{ backgroundColor: 'primary', fontSize: '18px', padding: 3 }}
          >
            Create your TalentMatch profile
          </a>
        </Sparkles>
        <Box sx={{ marginTop: 6 }}>
          <Box>
            <p
              style={{
                fontSize: '24px',
                fontWeight: 600,
                marginBottom: 6,
              }}
            >
              Looking for Black talent?
            </p>
            <Flex sx={{ flexDirection: ['column', 'row', 'row'] }}>
              <a
                href="https://airtable.com/shrMZCJIGqqRcn45Y"
                target="_blank"
                sx={{ backgroundColor: 'pink', fontSize: '18px' }}
                rel="noopener noreferrer"
                className="btn button-style button-purple read-more"
              >
                Join our job board!
              </a>{' '}
              <p
                style={{
                  fontSize: '24px',
                  marginLeft: '12px',
                  marginRight: '12px',
                  textAlign: 'center',
                }}
              >
                or
              </p>
              <a
                href="https://calendly.com/dayhaysoos/30min"
                target="_blank"
                sx={{ backgroundColor: 'pink', fontSize: '18px' }}
                rel="noopener noreferrer"
                className="btn button-style button-purple"
              >
                Learn about TalentMatch
              </a>{' '}
            </Flex>
          </Box>
        </Box>
      </Box>

      <Box
        sx={{
          maxWidth: '500px',
          marginBottom: '20px',
        }}
      >
        <Sparkles shouldHideOnMobile={true}>
          <Image
            src={BTPGraphic}
            alt="Image of 4 cartoon drawn people of color standing in front of colored pipes representing skills"
            sx={{
              marginBottom: '50px',
              maxWidth: '400px',
              display: ['none', 'block', 'block'],
            }}
          />
        </Sparkles>
      </Box>
    </Flex>
    <div
      sx={{ display: ['none', 'block', 'block'], marginBottom: '0.9rem' }}
      className="container py-xl-5 py-lg-3"
    >
      <h2 className="tittle text-center font-weight-bold">Featured In</h2>
      <FeaturedIn />
    </div>
    <Box className="bg-li" sx={{ paddingBottom: 4 }}>
      <Box sx={{ margin: '0 auto', marginBottom: 4, maxWidth: '700px' }}>
        <div
          style={{
            textAlign: 'center',
            paddingTop: '32px',
          }}
        >
          <Box as="p" sx={{ fontSize: '24px' }}>
            WHY USE BTP TALENTMATCH?
          </Box>

          <Box
            sx={{
              fontWeight: 400,
              fontSize: '36px',
              color: 'black',
              lineHeight: '48px',
              padding: 4,
            }}
            as="p"
          >
            Did you know that the average recruiter spends about{' '}
            <em>six seconds</em> looking at your resume?
          </Box>
          <Box sx={{ fontSize: 2 }} as="p">
            With so many applicants, even the most well-intentioned recruiter is
            likely to have some unconscious bias. But this puts many at a
            disadvantage from the start, solely due of their age, race, gender,
            or religion.
          </Box>
        </div>
      </Box>
    </Box>
    <Box sx={{ paddingTop: 4 }}>
      <Box
        sx={{
          fontSize: '2em',
          margin: '0 auto',
          textAlign: 'center',
          marginBottom: 3,
        }}
        as="h2"
      >
        That's why we're leveling the field
      </Box>
      <Box
        sx={{
          fontSize: '1.25em',
          margin: 'auto',
          marginBottom: 4,
          textAlign: 'center',
          padding: 4,
        }}
        as="p"
      >
        At Black Tech Pipeline, we’ve created TalentMatch to level the field for
        Black technologists, helping you to:
      </Box>
      <Grid
        sx={{
          paddingLeft: 4,
          margin: '0 auto',
          textAlign: 'center',
          marginBottom: 4,
        }}
        gap={5}
        columns={[1, 1, 3]}
      >
        <Box>
          <Box sx={{ fontSize: '1.5rem', marginBottom: 4 }} as="h3">
            BYPASS THE BIAS
          </Box>
          <Image
            src={Profile}
            css={{ width: '50%', marginBottom: '32px', aspectRatio: '4/4' }}
          />
          <Box
            sx={{
              fontSize: 2,
              marginBottom: 4,
            }}
            as="p"
          >
            We help you build an anonymized profile that showcases your
            highlights, talent, and experience.
          </Box>
        </Box>

        <Box>
          <Box sx={{ fontSize: '1.5rem', marginBottom: 4 }} as="h3">
            TAKE BACK CONTROL
          </Box>
          <Image
            src={NoSpam}
            css={{ width: '50%', marginBottom: '32px', aspectRatio: '4/4' }}
          />
          <Box
            sx={{
              fontSize: 2,
              marginBottom: 4,
            }}
            as="p"
          >
            No recruiter spam. You’ll only be contacted by the recruiters that
            you’re interested in speaking with.
          </Box>
        </Box>
        <Box>
          <Box sx={{ fontSize: '1.5rem', marginBottom: '0.9rem' }} as="h3">
            GET IN WHERE YOU FIT IN
          </Box>
          <Image
            src={Review}
            css={{ width: '50%', marginBottom: '32px', aspectRatio: '4/4.25' }}
          />
          <Box
            sx={{
              fontSize: 2,
              marginBottom: 5,
              marginBottom: 4,
            }}
            as="p"
          >
            We vet all employers on the platform to ensure that you land at a
            supportive & inclusive workplace.
          </Box>
        </Box>
      </Grid>
    </Box>
    <Box
      sx={{
        textAlign: 'center',
        fontWeight: 600,
        fontSize: 4,
        marginBottom: '1em',
      }}
    >
      Plus, you’ll be supported beyond the hiring process…
    </Box>
    <Box className="bg-li" sx={{ paddingTop: 4, paddingBottom: 2 }}>
      <Box sx={{ maxWidth: '700px', margin: '0 auto' }}>
        <Box sx={{ textAlign: 'center' }}>
          <Box
            sx={{ fontSize: '32px', color: 'black', fontWeight: 400 }}
            as="p"
          >
            OUR COMMITMENT
          </Box>
          <Box
            as="p"
            sx={{
              fontWeight: 600,
              fontSize: '2rem',
              color: 'black',
            }}
          >
            Each placement comes with 90 days of on-the-job support.
          </Box>
          <Box sx={{ fontSize: '16px', marginBottom: 4 }} as="p">
            We’re ensuring that you’re supported in your new workplace after you
            start your new position. With 90 days of biweekly virtual check-ins
            with you and your employer, we relay the feedback your employer
            needs to improve their policies and processes and we facilitate the
            support you need to flourish and succeed.
          </Box>
        </Box>
      </Box>
    </Box>
    <Box sx={{ paddingTop: 4, paddingBottom: 4, marginBottom: 4 }}>
      <Box
        sx={{
          textAlign: 'center',
          marginBottom: 5,
          fontSize: '2em',
        }}
        as="h2"
      >
        Here's How It Works
      </Box>
      <Grid
        sx={{ marginBottom: 4, paddingLeft: 4, paddingRight: 4 }}
        columns={[1, 2, 2, 4]}
      >
        <Box sx={{ textAlign: 'center' }}>
          <Box>
            <FaRegEdit color="#818a91" size={28} />
          </Box>
          <Box
            as="p"
            sx={{ fontSize: '1.25em', marginBottom: '0.9rem', color: 'black' }}
          >
            SIGN UP
          </Box>
          <Box as="p" sx={{ fontSize: 2 }}>
            Create your anonymized TalentMatch profile by filling in your
            experience, contributions, and skills.
          </Box>
        </Box>
        <Box sx={{ textAlign: 'center' }}>
          <FaRegBell color="#818a91" size={28} />
          <Box
            as="p"
            sx={{ fontSize: '1.25em', marginBottom: '0.9rem', color: 'black' }}
          >
            GET ALERTS
          </Box>
          <Box as="p" sx={{ fontSize: 2 }}>
            You’ll get email notifications whenever a company is looking to fill
            a position that fits your experience.
          </Box>
        </Box>
        <Box sx={{ textAlign: 'center' }}>
          <FaRegEnvelope color="#818a91" size={28} />
          <Box
            as="p"
            sx={{ fontSize: '1.25em', marginBottom: '0.9rem', color: 'black' }}
          >
            GET CONNECTED
          </Box>
          <Box sx={{ fontSize: 2 }} as="p">
            If you’re interested in an opportunity, then we’ll share your
            information and get the interview process started.
          </Box>
        </Box>
        <Box sx={{ textAlign: 'center' }}>
          <FaSuitcase color="#818a91" size={28} />
          <Box
            sx={{ fontSize: '1.25em', marginBottom: '0.9rem', color: 'black' }}
            as="p"
          >
            GET THE JOB
          </Box>
          <Box as="p" sx={{ fontSize: 2 }}>
            Once you’re hired, you’ll be set up for success with 90 days of
            support with biweekly virtual check-ins.
          </Box>
        </Box>
      </Grid>
    </Box>
    <Box
      as="p"
      sx={{
        textAlign: 'center',
        color: 'black',
        fontSize: 3,
        fontWeight: 600,
      }}
    >
      Ready to get started?
    </Box>
    <Flex sx={{ justifyContent: 'center', marginBottom: 6 }}>
      <Sparkles>
        <a
          href="https://app.blacktechpipeline.com"
          target="_blank"
          rel="noopener noreferrer"
          className="btn button-style mt-md-5 mt-4 read-more"
          sx={{ backgroundColor: 'primary', fontSize: 4 }}
        >
          Create your TalentMatch profile
        </a>
      </Sparkles>
    </Flex>
    <Box className="bg-li">
      <Box
        as="p"
        sx={{
          textAlign: 'center',
          fontSize: '32px',
          fontWeight: 400,
          color: 'black',
          fontFamily: 'Poppins',
          marginBottom: 4,
        }}
      >
        Testimonials
      </Box>
      <Box sx={{ width: '350px', margin: 'auto', marginBottom: 4 }}>
        <Image src={Testimonials} />
      </Box>

      <Box
        as="p"
        sx={{
          fontSize: '36px',
          textAlign: 'center',
          fontWeight: 600,
          color: 'black',
          marginBottom: '0.9rem',
          fontFamily: 'Poppins',
        }}
      >
        We get Black tech talent hired & supported.
      </Box>
      <Grid
        gap={10}
        columns={[1, 1, 2]}
        sx={{
          textAlign: 'center',
          margin: '0 auto',
        }}
      >
        <Box
          sx={{
            fontSize: 2,
            fontWeight: '400',
            padding: 4,
          }}
          as="p"
        >
          “I just wanted to say thank you for a job you posted a few weeks back
          for a software developer.{' '}
          <strong>I just got hired on full-time!“</strong> - <em> Anonymous</em>
        </Box>
        <Box
          sx={{
            fontSize: 2,
            fontWeight: '400',
            padding: 4,
          }}
          as="p"
        >
          “Thank you for All the work you do.{' '}
          <strong>I just received a verbal offer</strong>
          for a technical analyst position.” - <em> Anonymous</em>
        </Box>
        <Box
          sx={{
            fontSize: 2,
            fontWeight: '400',
            padding: 4,
          }}
          as="p"
        >
          “Some good news since we last spoke;{' '}
          <strong>
            we’ve moved to offer for a candidate whose source is BTP!
          </strong>
          “ - <em> Anonymous</em>
        </Box>
        <Box
          sx={{
            fontSize: 2,
            fontWeight: '400',
            padding: 4,
          }}
          as="p"
        >
          {' '}
          <strong>“We are now up to four employees referred via BTP</strong>,
          one of whom recently upgraded to a senior position and one of whom is
          also now a project manager.” - <em> Anonymous</em>
        </Box>
      </Grid>
    </Box>

    {/* <Box
          as="p"
          sx={{
            fontSize: '3em',
            textAlign: 'center',
            fontWeight: 600,
            color: 'black',
            padding: 4,
          }}
        >
          Ready to find your next opportunity?
          <Flex
            sx={{
              justifyContent: 'space-evenly',
              marginBottom: 6,
              flexDirection: ['column', 'column', 'row'],
            }}
          >
            <Sparkles>
              <a
                href="https://app.blacktechpipeline.com"
                target="_blank"
                rel="noopener noreferrer"
                className="btn button-style mt-md-5 mt-4 read-more"
                sx={{ backgroundColor: 'primary' }}
              >
                Create your TalentMatch profile
              </a>
            </Sparkles>
            <Sparkles>
              <a
                href="/jobs"
                rel="noopener noreferrer"
                className="btn button-style mt-md-5 mt-4 read-more"
                sx={{ backgroundColor: 'pink' }}
              >
                Check out the Job Board
              </a>
            </Sparkles>
          </Flex>
        </Box> */}

    {/* <Sparkles>
      <Image
        src={BTPGraphic2}
        alt="Cartoon drawing of people of color working together"
        className="Image-fluid mt-5"
        sx={{ width: '100%' }}
      />
    </Sparkles> */}
    <Flex sx={{ alignContent: 'center', justifyContent: 'center' }}>
      <div sx={{ paddingTop: '80px', paddingBottom: '20px' }}>
        <h3
          sx={{
            textAlign: 'center',
            fontWeight: 'bold',
          }}
        >
          Subscribe to our
          <span
            sx={{
              fontWeight: 'bold',
              color: 'pink',
            }}
          >
            {' '}
            newsletter{' '}
          </span>
        </h3>
        <p sx={{ textAlign: 'center' }}>
          Get the latest job openings, upcoming events, valuable resources and
          opportunities in your inbox weekly!
        </p>
        <iframe
          src="https://blacktechpipeline.substack.com/embed"
          title="Subscribe to Black Tech Pipeline"
          width="100%"
          height="320"
          sx={{
            border: '1px solid: #EEE',
            marginTop: '20px',
          }}
          frameborder="0"
          scrolling="no"
        ></iframe>
      </div>
    </Flex>
  </Layout>
)

export default IndexPage
